import CreateLoadingScheduleForm from '@components/loadingSchedule/CreateLoadingScheduleForm';
import { FiChevronLeft } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

const CreateLoadingIn = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="bg-white rounded-xl p-4">
        <div className='flex items-center'>
          <button onClick={() => navigate("/jadwal-loading/in")} className='pr-4'>
            <FiChevronLeft size={25} />
          </button>
          <h1 className="text-center text-xl w-full md:text-2xl lg:text-4xl font-semibold">Buat Jadwal Loading IN</h1>
        </div>
      </div>
      <div className='mt-10'>
        <CreateLoadingScheduleForm />
      </div>
    </div>
  )
}

export default CreateLoadingIn